import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import ClickTrackingWrapper from "../../click_tracking_wrapper";
import { TRACKED_CLASSES_AUDIBLE } from "../../../modules/ads/click_tracking_helper";
import classNames from "classnames";

export default GrComponentFactory.createClass({
  displayName: "YoutubeVideo",

  propTypes: {
    widgetTitle: React.PropTypes.string,
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    videoId: React.PropTypes.string,
    videoTitle: React.PropTypes.string,
    videoDescription: React.PropTypes.string,
    videoExternalLinkUrl: React.PropTypes.string,
    videoExternalLinkText: React.PropTypes.string,
    autoplay: React.PropTypes.bool,
  },

  getDefaultProps () {
    return {
      width: 300,
      height: 200,
      autoplay: false,
      trackingOptions: {
        enableTracking: true,
      },
    };
  },

  renderTitle () {
    if (this.props.widgetTitle) {
      return (<h3>{this.props.widgetTitle}</h3>);
    }
    return null;
  },

  renderVideoTitle () {
    if (this.props.videoTitle) {
      return (<div className="gr-youtubeVideo__title">
        {this.props.videoTitle}
      </div>);
    }
    return null;
  },

  renderVideoDescription () {
    if (this.props.videoDescription) {
      return (<div className="gr-youtubeVideo__description">
        {this.props.videoDescription}
      </div>);
    }
    return null;
  },

  renderExternalLink () {
    if (this.props.videoExternalLinkUrl) {
      const externalLink = (<form target="_blank" rel="noopener noreferrer"><button formAction={this.props.videoExternalLinkUrl} className="gr-button">
        {this.props.videoExternalLinkText}
      </button></form>);
      return <ClickTrackingWrapper children={externalLink} trackingOptions={TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Video_ExternalLink} />;
    }
    return null;
  },

  render () {
    const classnames = classNames(["gr-sponsoredWidget"]);
    let source = `//www.youtube.com/embed/${  this.props.videoId  }?autoplay=`;
    const autoplay = this.props.autoplay? "1" : "0";
    source += autoplay;
    const playerStyle = { width: this.props.width, display:"inline-block" };
    return (<div className={classnames}>
      {this.renderTitle()}
      <div style={playerStyle}>
        <iframe width={this.props.width} height={this.props.height} src={source} frameBorder={0} allowFullScreen />
      </div>
      <div className="gr-youtubeVideo__additionalContent">
        {this.renderVideoTitle()}
        {this.renderVideoDescription()}
        {this.renderExternalLink()}
      </div>
    </div>);

  },
});
